import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Spinner } from '@/components/ui/spinner'; // Assuming you have a spinner component

const DashboardRedirector: React.FC = () => {
  const { user, loading, getDashboardRoute } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="large" />
      </div>
    );
  }

  if (!user) {
    // This should ideally not happen if this component is used within a ProtectedRoute
    // but as a fallback, redirect to login.
    return <Navigate to="/login" replace />;
  }

  const dashboardPath = getDashboardRoute();
  
  return <Navigate to={dashboardPath} replace />;
};

export default DashboardRedirector; 